/* TailBlaze — restyle the product sticky add-to-cart bar to a full-width brand bar
   (like the reference) + add a Buy Now button. Runs at runtime so it never touches the
   large main-product.liquid section. Targets the stable .product-sticky-cart class. */
(function () {
  var CSS = [
    '.product-sticky-cart{left:0 !important;right:0 !important;bottom:0 !important;width:100% !important;max-width:none !important;border-radius:0 !important;box-shadow:0 -8px 26px rgba(20,15,60,.12) !important;overflow:visible !important;}',
    '.product-sticky-cart::before{background:#FFF6DE !important;border-top:1px solid rgba(20,15,60,.12);}',
    '.product-sticky-cart::after{display:none !important;}',
    '.product-sticky-cart .sticky-cart.page-width{display:flex;align-items:center;justify-content:space-between;gap:18px;max-width:1280px;margin:0 auto;padding:12px 20px;}',
    '.product-sticky-cart .sticky-cart__content{display:flex;align-items:center;gap:14px;min-width:0;}',
    '.product-sticky-cart .sticky-cart__content-heading .h4,.product-sticky-cart .sticky-cart__content-heading p,.product-sticky-cart .sticky-cart__content .price{color:#140F3C;}',
    '.product-sticky-cart .sticky-cart__form{flex:0 0 auto;}',
    '.product-sticky-cart .sticky-cart__form .product-form__buttons{display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;column-gap:12px;align-items:stretch;}',
    '.product-sticky-cart .product-form__submit{background:#fff !important;color:#140F3C !important;border:1.6px solid #140F3C !important;border-radius:999px !important;width:auto !important;min-width:180px !important;min-height:50px !important;padding:0 24px !important;font-weight:700 !important;box-shadow:none !important;transition:background .15s ease,color .15s ease;}',
    '.product-sticky-cart .product-form__submit:hover{background:#140F3C !important;color:#fff !important;}',
    '.product-sticky-cart .product-form__submit:hover .product-form__buttons-icon svg{stroke:#fff;}',
    '.product-sticky-cart .tb-sticky-buynow{display:inline-flex;align-items:center;justify-content:center;min-width:160px;min-height:50px;padding:0 28px;background:#C12068;color:#fff;border:1.6px solid #C12068;border-radius:999px;font-family:inherit;font-size:14px;font-weight:800;letter-spacing:.03em;text-transform:uppercase;cursor:pointer;transition:background .15s ease,border-color .15s ease,transform .12s ease;}',
    '.product-sticky-cart .tb-sticky-buynow:hover{background:#a51a58;border-color:#a51a58;transform:translateY(-1px);}',
    '.product-sticky-cart .tb-sticky-buynow:active{transform:translateY(0);}',
    '@media (max-width:749px){',
    '.product-sticky-cart{bottom:calc(var(--tbnav-h,62px) + var(--tbnav-safe,0px)) !important;}',
    '.product-sticky-cart .sticky-cart.page-width{gap:8px;padding:8px 10px;}',
    '.product-sticky-cart .sticky-cart__content-image{display:none !important;}',
    '.product-sticky-cart .sticky-cart__content{flex:1 1 auto;min-width:0;}',
    '.product-sticky-cart .sticky-cart__content-heading{min-width:0;}',
    '.product-sticky-cart .sticky-cart__content-heading .h4{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;font-size:12.5px;}',
    '.product-sticky-cart .sticky-cart__form{flex:0 0 auto;}',
    '.product-sticky-cart .sticky-cart__form .product-form__buttons{column-gap:8px;}',
    '.product-sticky-cart .product-form__submit{min-width:0 !important;padding:0 13px !important;min-height:44px !important;font-size:11.5px !important;white-space:nowrap;}',
    '.product-sticky-cart .tb-sticky-buynow{min-width:0;padding:0 15px;min-height:44px;font-size:11.5px;white-space:nowrap;}',
    '}'
  ].join('');

  function injectStyle() {
    if (document.getElementById('tb-sticky-style')) return;
    var st = document.createElement('style');
    st.id = 'tb-sticky-style';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function init() {
    var bar = document.querySelector('.product-sticky-cart');
    if (!bar) return;
    injectStyle();
    if (bar.dataset.tbBuy) return;
    bar.dataset.tbBuy = '1';

    var btns = bar.querySelector('.product-form__buttons');
    var addBtn = bar.querySelector('.product-form__submit');
    var form = bar.querySelector('form[data-type="add-to-cart-form"]') || bar.querySelector('.sticky-cart__form form');
    if (!btns || !addBtn || !form) return;
    if (addBtn.disabled) return;                 // sold out -> no Buy Now
    if (btns.querySelector('.tb-sticky-buynow')) return;

    var buy = document.createElement('button');
    buy.type = 'button';
    buy.className = 'tb-sticky-buynow';
    buy.setAttribute('aria-label', 'Buy now');
    buy.textContent = 'Buy Now';
    btns.appendChild(buy);

    buy.addEventListener('click', function () {
      var idInput = form.querySelector('[name="id"]');
      var vid = idInput ? idInput.value : '';     // the base / selected variant
      if (!vid) return;
      buy.disabled = true; buy.style.opacity = '0.7';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
